import {Injectable} from '@angular/core';
import {SceneService} from './scene.service';
import {RenderService} from './render.service';
import {LoaderService} from './loader.service';
import {ContainerService} from '../../Utils/container.service';
import {MouseControlsService} from '../Control/mouse-controls.service';
import {PictureService} from '../Picture/picture.service';
import {CameraService} from './camera.service';
import {DirectionalLight, DoubleSide, Mesh, MeshBasicMaterial, PlaneGeometry} from 'three';

@Injectable({
    providedIn: 'root'
})
export class StartUp {

    private reload = true;
    constructor(private sceneService: SceneService,
                private renderService: RenderService,
                private loaderService: LoaderService,
                private containerService: ContainerService,
                private controlService: MouseControlsService,
                private pictureService: PictureService,
                private cameraService: CameraService) {
        // this.initScene();
    }

    // public init() {
    //     this.sceneService.initScene();
    //     this.cameraService.initCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000, 375);
    //     this.initScene();
    // }

    getImage() {
        const material = new MeshBasicMaterial({
            opacity: 0.0
        });
        material.transparent = true;
        return material;
    }

    public initScene() {
        this.sceneService.initScene();
        this.cameraService.initCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000, 375);
        this.loaderService.initLoaderService(this.reload);
        this.addLight();

        this.sceneService.addObject(this.containerService.renderGroup);
        if (this.reload) {
            this.addImageHelpPlane();
        }
    }

    private addImageHelpPlane() {
        this.sceneService.enableImageMode(true);
        this.containerService.imagePlane.name = 'imagePlane';
        this.containerService.helpPlane.name = 'helpPlane';
        const geometry = new PlaneGeometry(1, 1, 32);
        geometry.center();
        const material = this.getImage();
        const plane = new Mesh(geometry, material);
        this.containerService.imagePlane.add(plane);

        const geometry_help = new PlaneGeometry(1000, 1000, 32);
        geometry_help.center();
        const helpPlane = new Mesh(geometry_help, new MeshBasicMaterial({
            color: 0x000000, opacity: 1, side: DoubleSide,
            transparent: true
        }));
        this.containerService.helpPlane.add(helpPlane);
        this.containerService.helpPlane.position.set(0, 0, 0);
    }

    private addLight() {
        const light = new DirectionalLight();
        this.sceneService.addGroup('lightGroup');
        this.sceneService.getGroupByName('lightGroup').add(light);
        this.sceneService.getGroupByName('lightGroup').add(light.target);
        light.position.copy(this.cameraService.camera.position);
    }

    // get paintMode(): boolean {
    //     return this.containerService.paintMode;
    // }

    public switchView(view: string) {
        if (view === 'shape') {
            this.controlService.dblClickEnabled = false;
        } else if (view === 'editor') {
            this.controlService.dblClickEnabled = true;
            this.renderService.setCameraZ(this.containerService.renderGroup.children[0]);
            this.cameraService.camera.position.y = 0;
            this.cameraService.resetViewOffset();
        }
    }

    public initRenderer(canvas, reload: boolean) {
        this.renderService.initRenderer(canvas, reload);
        this.reload = reload;
    }

    public setCanvasSize(width: number, height: number) {
        this.containerService.canvasWidth = width;
        this.containerService.canvasHeight = height;
    }
}
